import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";

interface UseRegressLeadProps {
  id?: string
  onSuccess: () => void
  onError: () => void
}

const useRegressLead = ({ id, onSuccess, onError }: UseRegressLeadProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['regressLead'],
    mutationFn: async () => {
      await privateAxios.put(`/funnel/private_company_leads/${id}/regress`)
    },
    onSuccess,
    onError,
  });
}

export default useRegressLead